export const toTitleCase = (str: string): string => {
  return str.replace(/\w\S*/g, (txt: string) => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const formatNumber = (n: number) => {
  return new Intl.NumberFormat("en-AU", {
    maximumSignificantDigits: 5,
  }).format(Math.ceil(n));
};

export const capitalize = (str: string): string => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};
